<template>
  <div class="zbhxr" v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">推荐中标候选人</p>
        <div class="rt">
          <el-button type="primary" @click="lookRules" :disabled="waitLoading"
            >查看规则</el-button
          >
          <el-button type="primary" @click="lookJjgg" :disabled="waitLoading"
            >查看竞价公告</el-button
          >
          <el-button
            type="primary"
            @click="handleCount"
            :disabled="waitLoading || kbxmlc.zt == '2'"
            v-if="role == 'Z'"
            >计算</el-button
          >
          
          <Draw ref="draw" style="margin-left: 10px;" @success="getData" />
        </div>
      </div>
      <draw-bid-concession-rate></draw-bid-concession-rate>
      <div class="tip">
        <div style="display: flex">
          <div v-for="(item, index) in parameterExtractionResults" :key="index">
            <span style="margin-right: 30px"
              >{{ item.parameter }}{{ item.value }}{{ item.unit }}</span
            >
          </div>
        </div>

        <div class="draw-info">
          <span>推荐中标候选人个数: {{ zbhxrgsNum }}</span>
          <span v-if="drawType != 2">候选人抽签方式: {{ drawTypeConfig[drawType] }}</span>
          <span v-if="drawRateType != 2">中标让利率抽签方式: {{ drawRateTypeConfig[drawRateType] }}</span>
        </div>

      </div>
      <div style="height: 100%; overflow: auto">
        <el-table ref="table" border :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="投标单位名称"
            show-overflow-tooltip
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="tenderQuotation"
            :label="`投标报价(${unit})`"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.tenderQuotation }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in exhibitionList"
            :key="item.prop"
            :label="item.mc"
            :prop="item.prop"
          ></el-table-column>
          <!-- <template v-else>
          <el-table-column
            prop="commercialBidScore"
            label="商务标得分"
            width="150"
          ></el-table-column>
        </template> -->

          <!-- <el-table-column
            prop="rank"
            label="排名"
            width="120"
          /> -->

          <!-- 因为评审结果内容一直为空，需求要求注释掉 -->
          <!-- <el-table-column prop="complianceReview" label="评审结果" width="120">
            <template slot-scope="scope">
              {{ scope.row.complianceReview == "1" ? "" : "不通过" }}
            </template>
          </el-table-column> -->

          <el-table-column v-if="checkDrawLots" prop="isWinning" label="抽签结果" width="120">
            <template slot-scope="scope">
              <i v-if="scope.row.isWinning == 2" class="el-icon-check" />
            </template>
          </el-table-column>

          <el-table-column
            prop="winningCandidate"
            label="推荐中标候选人"
            width="200"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.winningCandidate"
                placeholder="请选择"
                value-key="value"
                :disabled="
                  scope.row.disabled || !isSelectDisabeled || kbxmlc.zt == '2'
                "
                @change="saveWinningCandidate(scope.row)"
              >
                <el-option
                  v-for="item in newOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="clear">
          <pagination
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @changePage="changePage"
          >
          </pagination>
        </div>
      </div>

      <el-button
        v-if="!isTbr && kbxmlc.zt != '2'"
        type="primary lcNext"
        :disabled="waitLoading || sfcyjs == 0"
        @click="nextBtn"
        >下一步</el-button>
    </div>
    <!-- 添加投标单位弹窗 -->
    <el-dialog
      title="查看规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p v-for="(item, index) in rules" :key="index">{{ item }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
  <script>
import { numberToChinese } from "@/utils";
import Pagination from "@/components/Pagination";
import DrawStateMixin from '@/mixins/DrawStateMixin.js';
import Draw from '@/components/draw';
import DrawBidConcessionRate from '@/components/draw/drawBidConcessionRate'

export default {
  name: "tjzbhxr", //开评一体 推荐中标候选人
  components: {
    Pagination, Draw, DrawBidConcessionRate
  },
  mixins: [DrawStateMixin],
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableData: [],
      zbhxr: null,
      currentPage: 1,
      pageSize: 10,
      isOk: false, //是否提交保存过中标候选人
      options: [
        { label: "请选择", id: 0 },
        { label: "第一中标候选人", id: 1 },
      ],
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      unit: "",
      newOrOld: "0",
      exhibitionList: [],
      zbhxrgsNum: 0,
      newOptions: [],
      showRules: false,
      rules: [],
      parameterExtractionResults: [],
      sfcyjs: 0,
      total: 0,
      drawType: 2, // 候选人抽签方式 0:线上抽签 1:线下抽签 2:未选择
      drawTypeConfig: ['线上抽签','线下抽签'],
      drawRateType: 2, // 中标让利率抽签方式 0:线上抽签 1:线下抽签 2:未选择
      drawRateTypeConfig: ['线上抽签','线下抽签'],
    };
  },
  computed: {
    // select能否可选
    isSelectDisabeled() {
      return this.kbxmlc.zt == "1" && ["T", "A", "Z"].includes(this.role);
    },
    codeBtnDisabel() {
      return (res) => {
        if (res.length > 1) {
          let arr = res.map((el) => {
            return el.rank == "1";
          });
          if (arr.length > 1) {
            return false && kbxmlc.zt == "2";
          }
        } else {
          return true;
        }
      };
    },
    kbxmId() {
      return this.kbxmlc?.kbxmId || ''
    },
    isTbr() {
      return ["B"].includes(this.role);
    }
  },
  beforeDestroy() {
    window.removeEventListener("storage");
  },
  methods: {
    // 中标让利率抽签方式
    async getDrawRateType() {
      const res = await this.$api.getDrawRateType();
      if (!res.data.meta.success) {
        throw new Error(res.data.meta.message);
      }
      this.drawRateType = res.data.data;
    },
    // 候选人抽签方式
    async getDrawTypeState() {
      try {
        const { data } = await this.$api.getDrawTypeState();
        this.drawType = data.data;
      } catch(err) {
        console.error('getDrawTypeState fail', err);
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    async handleCount() {
      try {
        this.waitLoading = true;
        // 根据列表接口中返回的newOrOld来判断调用新旧计算接口
        let res = await this.$api.calculateCommercialBidScoreNew({
          djlcId: this.djlcId,
        });
        if (res.status == 200) {
          this.$refs.draw.update()

          this.$message({ type: "success", message: "操作成功！" });
          this.getData();
          let obj = {
            lx: "zb",
            data: {
              id: "",
            },
          };
          this.$emit("send", JSON.stringify(obj));
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async lookRules() {
      let para = { kbxmId: this.kbxmlc.kbxmId };
      try {
        let res = await this.$api.getPbbfcsByKbxmId(para);
        if (res.status == 200) {
          this.rules = res.data.data;
          this.showRules = true;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async lookJjgg() {
      const res = await this.$api.noticeView();
      let blob = new Blob([res.data], {
        type: "application/pdf",
      });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    getNewOptions(data) {
      let arr = [{ label: "请选择", value: 0 }];
      for (let i = 0; i < data; i++) {
        let obj = {
          label: `第${numberToChinese(i + 1)}中标候选人`,
          value: i + 1,
        };
        arr.push(obj);
      }
      return arr;
    },
    getData() {
      this.initDrawState() // 抽签状态初始化

      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.$api
        .getWinningCandidateList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.waitLoading = false;
            this.kbxmlc = res.data.data.kbxmlc;
            // 新逻辑
            this.unit = res.data.data.unit;
            this.zbhxrgsNum = res.data.data.zbhxrgsNum;
            this.newOptions = this.getNewOptions(this.zbhxrgsNum);
            this.parameterExtractionResults =
              res.data.data.parameterExtractionResults || [];
            this.tableData = res.data.data.page.list || [];
            this.total = res.data.data.page.total || 0;
            this.sfcyjs = res.data.data.sfcyjs;
            // 对中间值进行排序 并预设中间值的取值键名
            this.exhibitionList = (res.data.data.exhibition || [])
              .sort((a, b) => a.pxh - b.pxh)
              .map((item, index) => {
                return {
                  ...item,
                  prop: `exhibition${index}`,
                };
              });
            this.tableData.forEach((el) => {
              if (el.exhibition && el.exhibition.includes("不入围")) {
                el.disabled = true;
              }
              if (el.complianceReview === "0") {
                el.complianceReview = "";
                // 如果数据列表中 exhibition字段存在且不为空 则按照预设键名新增键并赋值
              }
              if (el?.exhibition) {
                el.exhibition.split(",").forEach((item, index) => {
                  el[`exhibition${index}`] = item;
                });
              } else {
                // 如果无值 则预设键名 并赋值为空
                this.exhibitionList.forEach((item) => {
                  el[item.prop] = "";
                });
              }
            });
            this.getWinningCandidateFlag();
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.mesage,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    async saveWinningCandidate(row) {
      try {
        let para = {
          djlcId: this.djlcId,
          jgdm: row.companyCode,
          zbhxr: row.winningCandidate,
        };
        this.waitLoading = true;
        let res = await this.$api.saveWinningCandidate(para);
        if (res.data.meta.success) {
          this.getWinningCandidateFlag();
        } else {
          this.$message({ type: "error", message: res.data.meta.message });
        }
        this.waitLoading = false;
      } catch (err) {
        this.waitLoading = false;
        row.winningCandidate = 0;
        this.$message({ type: "error", message: err.data.meta.message });
      }
    },
    async getWinningCandidateFlag() {
      try {
        this.waitLoading = true;
        let res = await this.$api.getWinningCandidateFlag({
          djlcId: this.djlcId,
        });
        if (res.status == 200) {
          this.isOk = res.data.data;
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    handleNext(arr) {
      const candidates = new Set();
      for (let i = 0; i < arr.length; i++) {
        const candidate = arr[i].winningCandidate;
        if (candidates.has(candidate)) {
          return false;
        }
        candidates.add(candidate);
      }
      return true;
    },
    nextBtn() {
      // if (this.handleNext(this.tableData)) {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("bxNextBtn", para);
      // } else {
      //   this.$message({
      //     type: "warning",
      //     message: "推荐中标候选人不能重复",
      //   });
      // }
    },
    draw() {
      // 打开新标签 并且监听新标签抽中的参数
      let _this = this;
      let arr = _this.tableData.map((el, index) => {
        if (el.rank == "1") {
          return index + 1;
        }
      });
      let url = `/draw?userData=${encodeURIComponent(JSON.stringify(arr))}`;
      window.open(url, "_blank");
      window.addEventListener("storage", function (event) {
        if (event.key === "myParam" && event.newValue !== null) {
          // 从新标签页传递回来的参数
          const param = JSON.parse(event.newValue);
          if (param.result.length > 0) {
            _this.saveWinningCandidate(_this.tableData[param.result[0].jg - 1]);
            _this.zbhxr = _this.tableData[param.result[0].jg - 1].companyCode;
          }
        }
      });
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
    this.getDrawRateType();
    this.getDrawTypeState();
  },
};
</script>
  <style lang="less">
.footer {
  display: flex;
  align-items: center;
}
.box {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.zbhxr {
  td {
    .el-input__inner,
    .el-input__icon {
      height: 29px;
      line-height: 29px;
    }
  }
}
.tip {
  display: flex;
  justify-content: space-between;
  color: #d70a30;
  padding: 0 8px;
  .draw-info {
    span {
      margin: 0 10px;
    }
  }
}
</style>